import React from 'react';
import { useSelector } from "react-redux";

import PortalActions from './PortalActions';

// Create two portals into title to do some custom actions
function PlayerActionsWrapper() {
  const deckItemA = useSelector( state => state.deckItemA );
  const deckItemB= useSelector( state => state.deckItemB );

  return (
    <>
      {deckItemA && <PortalActions rootID={`deck1-actions`} item={deckItemA} />} 
      {deckItemB && <PortalActions rootID={`deck2-actions`} item={deckItemB} />}
    </>
  )
}

export default PlayerActionsWrapper;
